import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import { useEffect, useRef, useState } from "react";
import { useI18N } from "../context/I18NContext";
const ErrorAlert = ({ messages, setter, noAutoClose, scrollIntoView }) => {
    const { t } = useI18N();
    const [errors, setErrors] = useState();
    const ref = useRef(null);
    useEffect(() => {
        setErrors(messages);
        if (!noAutoClose) {
            setTimeout(() => {
                setErrors(undefined);
                if (setter)
                    setter(undefined);
            }, 5000);
        }
    }, [messages]);
    // bring this alert into view when it gains messages (offset for a sticky header)
    useEffect(() => {
        var _a;
        if (scrollIntoView && errors && errors.length > 0) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [errors]);
    return (_jsx(Collapse, { in: !!errors, children: _jsx("div", { ref: ref, style: scrollIntoView ? { scrollMarginTop: 120 } : undefined, children: _jsx(Alert, { sx: { my: 2 }, severity: "error", onClose: () => {
                    setErrors(undefined);
                    if (setter)
                        setter(undefined);
                }, children: errors === null || errors === void 0 ? void 0 : errors.map((_error, i) => (_jsx(Typography, { children: t(_error) }, i))) }) }) }));
};
export default ErrorAlert;
